import React from 'react'
import { PERMISSIONS } from 'src/config/roleConfig'

// Minimum number of items before a search input is shown in dropdowns.
export const DROPDOWN_SEARCH_THRESHOLD = 10

export interface SelectItem {
  name: string | JSX.Element
  value: string | number
  icon?: string | JSX.Element
  childIds?: string[]
  parentId?: string
  categoryId?: string
}

export type SelectDropdownProps = {
  label: string
  labelButton?: JSX.Element
  items?: SelectItem[]
  categories?: { id: string; name: string }[]
  defaultValues?: SelectItem[]
  onSelectCb: (value: SelectItem[]) => void
  placeholder?: React.ReactNode
  isMultiSelect?: boolean
  isRequired?: boolean
  errMsg?: string | JSX.Element
  isWarning?: boolean
  formatLabel?: (label: string) => string | JSX.Element
  alwaysShowError?: boolean
  requiredPermissions?: PERMISSIONS[]
  isDisabled?: boolean
  isBoldLabel?: boolean
  customOnToggle?: () => void
  hideError?: boolean
  prefix?: JSX.Element
  isSearchable?: boolean
  hideLabel?: boolean
}

// Controls the auto close behavior of the dropdown when clicking outside of the button or the list.
export type DropdownAutoClose = 'outside' | 'inside' | boolean

export const COUNTRY_LIST: SelectItem[] = [
  { name: 'United States', value: 'USA' },
  { name: 'Afghanistan', value: 'AFG' },
  { name: 'Aland Islands', value: 'ALA' },
  { name: 'Albania', value: 'ALB' },
  { name: 'Algeria', value: 'DZA' },
  { name: 'American Samoa', value: 'ASM' },
  { name: 'Andorra', value: 'AND' },
  { name: 'Angola', value: 'AGO' },
  { name: 'Anguilla', value: 'AIA' },
  { name: 'Antarctica', value: 'ATA' },
  { name: 'Antigua and Barbuda', value: 'ATG' },
  { name: 'Argentina', value: 'ARG' },
  { name: 'Armenia', value: 'ARM' },
  { name: 'Aruba', value: 'ABW' },
  { name: 'Australia', value: 'AUS' },
  { name: 'Austria', value: 'AUT' },
  { name: 'Azerbaijan', value: 'AZE' },
  { name: 'Bahamas', value: 'BHS' },
  { name: 'Bahrain', value: 'BHR' },
  { name: 'Bangladesh', value: 'BGD' },
  { name: 'Barbados', value: 'BRB' },
  { name: 'Belarus', value: 'BLR' },
  { name: 'Belgium', value: 'BEL' },
  { name: 'Belize', value: 'BLZ' },
  { name: 'Benin', value: 'BEN' },
  { name: 'Bermuda', value: 'BMU' },
  { name: 'Bhutan', value: 'BTN' },
  { name: 'Bolivia', value: 'BOL' },
  { name: 'Bonaire, Sint Eustatius and Saba', value: 'BES' },
  { name: 'Bosnia and Herzegovina', value: 'BIH' },
  { name: 'Botswana', value: 'BWA' },
  { name: 'Bouvet Island', value: 'BVT' },
  { name: 'Brazil', value: 'BRA' },
  { name: 'British Indian Ocean Territory', value: 'IOT' },
  { name: 'Brunei Darussalam', value: 'BRN' },
  { name: 'Bulgaria', value: 'BGR' },
  { name: 'Burkina Faso', value: 'BFA' },
  { name: 'Burundi', value: 'BDI' },
  { name: 'Cambodia', value: 'KHM' },
  { name: 'Cameroon', value: 'CMR' },
  { name: 'Canada', value: 'CAN' },
  { name: 'Cape Verde', value: 'CPV' },
  { name: 'Cayman Islands', value: 'CYM' },
  { name: 'Central African Republic', value: 'CAF' },
  { name: 'Chad', value: 'TCD' },
  { name: 'Chile', value: 'CHL' },
  { name: 'China', value: 'CHN' },
  { name: 'Christmas Island', value: 'CXR' },
  { name: 'Cocos (Keeling) Islands', value: 'CCK' },
  { name: 'Colombia', value: 'COL' },
  { name: 'Comoros', value: 'COM' },
  { name: 'Congo', value: 'COG' },
  { name: 'Congo, Democratic Republic of the Congo', value: 'COD' },
  { name: 'Cook Islands', value: 'COK' },
  { name: 'Costa Rica', value: 'CRI' },
  { name: "Cote D'Ivoire", value: 'CIV' },
  { name: 'Croatia', value: 'HRV' },
  { name: 'Cuba', value: 'CUB' },
  { name: 'Curacao', value: 'CUW' },
  { name: 'Cyprus', value: 'CYP' },
  { name: 'Czech Republic', value: 'CZE' },
  { name: 'Denmark', value: 'DNK' },
  { name: 'Djibouti', value: 'DJI' },
  { name: 'Dominica', value: 'DMA' },
  { name: 'Dominican Republic', value: 'DOM' },
  { name: 'Ecuador', value: 'ECU' },
  { name: 'Egypt', value: 'EGY' },
  { name: 'El Salvador', value: 'SLV' },
  { name: 'Equatorial Guinea', value: 'GNQ' },
  { name: 'Eritrea', value: 'ERI' },
  { name: 'Estonia', value: 'EST' },
  { name: 'Ethiopia', value: 'ETH' },
  { name: 'Falkland Islands (Malvinas)', value: 'FLK' },
  { name: 'Faroe Islands', value: 'FRO' },
  { name: 'Fiji', value: 'FJI' },
  { name: 'Finland', value: 'FIN' },
  { name: 'France', value: 'FRA' },
  { name: 'French Guiana', value: 'GUF' },
  { name: 'French Polynesia', value: 'PYF' },
  { name: 'French Southern Territories', value: 'ATF' },
  { name: 'Gabon', value: 'GAB' },
  { name: 'Gambia', value: 'GMB' },
  { name: 'Georgia', value: 'GEO' },
  { name: 'Germany', value: 'DEU' },
  { name: 'Ghana', value: 'GHA' },
  { name: 'Gibraltar', value: 'GIB' },
  { name: 'Greece', value: 'GRC' },
  { name: 'Greenland', value: 'GRL' },
  { name: 'Grenada', value: 'GRD' },
  { name: 'Guadeloupe', value: 'GLP' },
  { name: 'Guam', value: 'GUM' },
  { name: 'Guatemala', value: 'GTM' },
  { name: 'Guernsey', value: 'GGY' },
  { name: 'Guinea', value: 'GIN' },
  { name: 'Guinea-Bissau', value: 'GNB' },
  { name: 'Guyana', value: 'GUY' },
  { name: 'Haiti', value: 'HTI' },
  { name: 'Heard Island and Mcdonald Islands', value: 'HMD' },
  { name: 'Holy See (Vatican City State)', value: 'VAT' },
  { name: 'Honduras', value: 'HND' },
  { name: 'Hong Kong', value: 'HKG' },
  { name: 'Hungary', value: 'HUN' },
  { name: 'Iceland', value: 'ISL' },
  { name: 'India', value: 'IND' },
  { name: 'Indonesia', value: 'IDN' },
  { name: 'Iran, Islamic Republic of', value: 'IRN' },
  { name: 'Iraq', value: 'IRQ' },
  { name: 'Ireland', value: 'IRL' },
  { name: 'Isle of Man', value: 'IMN' },
  { name: 'Israel', value: 'ISR' },
  { name: 'Italy', value: 'ITA' },
  { name: 'Jamaica', value: 'JAM' },
  { name: 'Japan', value: 'JPN' },
  { name: 'Jersey', value: 'JEY' },
  { name: 'Jordan', value: 'JOR' },
  { name: 'Kazakhstan', value: 'KAZ' },
  { name: 'Kenya', value: 'KEN' },
  { name: 'Kiribati', value: 'KIR' },
  { name: "Korea, Democratic People's Republic of", value: 'PRK' },
  { name: 'Korea, Republic of', value: 'KOR' },
  { name: 'Kosovo', value: 'XKX' },
  { name: 'Kuwait', value: 'KWT' },
  { name: 'Kyrgyzstan', value: 'KGZ' },
  { name: "Lao People's Democratic Republic", value: 'LAO' },
  { name: 'Latvia', value: 'LVA' },
  { name: 'Lebanon', value: 'LBN' },
  { name: 'Lesotho', value: 'LSO' },
  { name: 'Liberia', value: 'LBR' },
  { name: 'Libyan Arab Jamahiriya', value: 'LBY' },
  { name: 'Liechtenstein', value: 'LIE' },
  { name: 'Lithuania', value: 'LTU' },
  { name: 'Luxembourg', value: 'LUX' },
  { name: 'Macao', value: 'MAC' },
  { name: 'Macedonia, the Former Yugoslav Republic of', value: 'MKD' },
  { name: 'Madagascar', value: 'MDG' },
  { name: 'Malawi', value: 'MWI' },
  { name: 'Malaysia', value: 'MYS' },
  { name: 'Maldives', value: 'MDV' },
  { name: 'Mali', value: 'MLI' },
  { name: 'Malta', value: 'MLT' },
  { name: 'Marshall Islands', value: 'MHL' },
  { name: 'Martinique', value: 'MTQ' },
  { name: 'Mauritania', value: 'MRT' },
  { name: 'Mauritius', value: 'MUS' },
  { name: 'Mayotte', value: 'MYT' },
  { name: 'Mexico', value: 'MEX' },
  { name: 'Micronesia, Federated States of', value: 'FSM' },
  { name: 'Moldova, Republic of', value: 'MDA' },
  { name: 'Monaco', value: 'MCO' },
  { name: 'Mongolia', value: 'MNG' },
  { name: 'Montenegro', value: 'MNE' },
  { name: 'Montserrat', value: 'MSR' },
  { name: 'Morocco', value: 'MAR' },
  { name: 'Mozambique', value: 'MOZ' },
  { name: 'Myanmar', value: 'MMR' },
  { name: 'Namibia', value: 'NAM' },
  { name: 'Nauru', value: 'NRU' },
  { name: 'Nepal', value: 'NPL' },
  { name: 'Netherlands', value: 'NLD' },
  { name: 'Netherlands Antilles', value: 'ANT' },
  { name: 'New Caledonia', value: 'NCL' },
  { name: 'New Zealand', value: 'NZL' },
  { name: 'Nicaragua', value: 'NIC' },
  { name: 'Niger', value: 'NER' },
  { name: 'Nigeria', value: 'NGA' },
  { name: 'Niue', value: 'NIU' },
  { name: 'Norfolk Island', value: 'NFK' },
  { name: 'Northern Mariana Islands', value: 'MNP' },
  { name: 'Norway', value: 'NOR' },
  { name: 'Oman', value: 'OMN' },
  { name: 'Pakistan', value: 'PAK' },
  { name: 'Palau', value: 'PLW' },
  { name: 'Palestinian Territory, Occupied', value: 'PSE' },
  { name: 'Panama', value: 'PAN' },
  { name: 'Papua New Guinea', value: 'PNG' },
  { name: 'Paraguay', value: 'PRY' },
  { name: 'Peru', value: 'PER' },
  { name: 'Philippines', value: 'PHL' },
  { name: 'Pitcairn', value: 'PCN' },
  { name: 'Poland', value: 'POL' },
  { name: 'Portugal', value: 'PRT' },
  { name: 'Puerto Rico', value: 'PRI' },
  { name: 'Qatar', value: 'QAT' },
  { name: 'Reunion', value: 'REU' },
  { name: 'Romania', value: 'ROM' },
  { name: 'Russian Federation', value: 'RUS' },
  { name: 'Rwanda', value: 'RWA' },
  { name: 'Saint Barthelemy', value: 'BLM' },
  { name: 'Saint Helena', value: 'SHN' },
  { name: 'Saint Kitts and Nevis', value: 'KNA' },
  { name: 'Saint Lucia', value: 'LCA' },
  { name: 'Saint Martin', value: 'MAF' },
  { name: 'Saint Pierre and Miquelon', value: 'SPM' },
  { name: 'Saint Vincent and the Grenadines', value: 'VCT' },
  { name: 'Samoa', value: 'WSM' },
  { name: 'San Marino', value: 'SMR' },
  { name: 'Sao Tome and Principe', value: 'STP' },
  { name: 'Saudi Arabia', value: 'SAU' },
  { name: 'Senegal', value: 'SEN' },
  { name: 'Serbia', value: 'SRB' },
  { name: 'Serbia and Montenegro', value: 'SCG' },
  { name: 'Seychelles', value: 'SYC' },
  { name: 'Sierra Leone', value: 'SLE' },
  { name: 'Singapore', value: 'SGP' },
  { name: 'Sint Maarten', value: 'SXM' },
  { name: 'Slovakia', value: 'SVK' },
  { name: 'Slovenia', value: 'SVN' },
  { name: 'Solomon Islands', value: 'SLB' },
  { name: 'Somalia', value: 'SOM' },
  { name: 'South Africa', value: 'ZAF' },
  { name: 'South Georgia and the South Sandwich Islands', value: 'SGS' },
  { name: 'South Sudan', value: 'SSD' },
  { name: 'Spain', value: 'ESP' },
  { name: 'Sri Lanka', value: 'LKA' },
  { name: 'Sudan', value: 'SDN' },
  { name: 'Suriname', value: 'SUR' },
  { name: 'Svalbard and Jan Mayen', value: 'SJM' },
  { name: 'Swaziland', value: 'SWZ' },
  { name: 'Sweden', value: 'SWE' },
  { name: 'Switzerland', value: 'CHE' },
  { name: 'Syrian Arab Republic', value: 'SYR' },
  { name: 'Taiwan, Province of China', value: 'TWN' },
  { name: 'Tajikistan', value: 'TJK' },
  { name: 'Tanzania, United Republic of', value: 'TZA' },
  { name: 'Thailand', value: 'THA' },
  { name: 'Timor-Leste', value: 'TLS' },
  { name: 'Togo', value: 'TGO' },
  { name: 'Tokelau', value: 'TKL' },
  { name: 'Tonga', value: 'TON' },
  { name: 'Trinidad and Tobago', value: 'TTO' },
  { name: 'Tunisia', value: 'TUN' },
  { name: 'Turkey', value: 'TUR' },
  { name: 'Turkmenistan', value: 'TKM' },
  { name: 'Turks and Caicos Islands', value: 'TCA' },
  { name: 'Tuvalu', value: 'TUV' },
  { name: 'Uganda', value: 'UGA' },
  { name: 'Ukraine', value: 'UKR' },
  { name: 'United Arab Emirates', value: 'ARE' },
  { name: 'United Kingdom', value: 'GBR' },
  { name: 'United States Minor Outlying Islands', value: 'UMI' },
  { name: 'Uruguay', value: 'URY' },
  { name: 'Uzbekistan', value: 'UZB' },
  { name: 'Vanuatu', value: 'VUT' },
  { name: 'Venezuela', value: 'VEN' },
  { name: 'Viet Nam', value: 'VNM' },
  { name: 'Virgin Islands, British', value: 'VGB' },
  { name: 'Virgin Islands, U.S.', value: 'VIR' },
  { name: 'Wallis and Futuna', value: 'WLF' },
  { name: 'Western Sahara', value: 'ESH' },
  { name: 'Yemen', value: 'YEM' },
  { name: 'Zambia', value: 'ZMB' },
  { name: 'Zimbabwe', value: 'ZWE' },
]

// United States States
export const USA_STATES_LIST: SelectItem[] = [
  { name: 'Alabama', value: 'AL' },
  { name: 'Alaska', value: 'AK' },
  { name: 'Arizona', value: 'AZ' },
  { name: 'Arkansas', value: 'AR' },
  { name: 'California', value: 'CA' },
  { name: 'Colorado', value: 'CO' },
  { name: 'Connecticut', value: 'CT' },
  { name: 'Delaware', value: 'DE' },
  { name: 'Florida', value: 'FL' },
  { name: 'Georgia', value: 'GA' },
  { name: 'Hawaii', value: 'HI' },
  { name: 'Idaho', value: 'ID' },
  { name: 'Illinois', value: 'IL' },
  { name: 'Indiana', value: 'IN' },
  { name: 'Iowa', value: 'IA' },
  { name: 'Kansas', value: 'KS' },
  { name: 'Kentucky', value: 'KY' },
  { name: 'Louisiana', value: 'LA' },
  { name: 'Maine', value: 'ME' },
  { name: 'Maryland', value: 'MD' },
  { name: 'Massachusetts', value: 'MA' },
  { name: 'Michigan', value: 'MI' },
  { name: 'Minnesota', value: 'MN' },
  { name: 'Mississippi', value: 'MS' },
  { name: 'Missouri', value: 'MO' },
  { name: 'Montana', value: 'MT' },
  { name: 'Nebraska', value: 'NE' },
  { name: 'Nevada', value: 'NV' },
  { name: 'New Hampshire', value: 'NH' },
  { name: 'New Jersey', value: 'NJ' },
  { name: 'New Mexico', value: 'NM' },
  { name: 'New York', value: 'NY' },
  { name: 'North Carolina', value: 'NC' },
  { name: 'North Dakota', value: 'ND' },
  { name: 'Ohio', value: 'OH' },
  { name: 'Oklahoma', value: 'OK' },
  { name: 'Oregon', value: 'OR' },
  { name: 'Pennsylvania', value: 'PA' },
  { name: 'Rhode Island', value: 'RI' },
  { name: 'South Carolina', value: 'SC' },
  { name: 'South Dakota', value: 'SD' },
  { name: 'Tennessee', value: 'TN' },
  { name: 'Texas', value: 'TX' },
  { name: 'Utah', value: 'UT' },
  { name: 'Vermont', value: 'VT' },
  { name: 'Virginia', value: 'VA' },
  { name: 'Washington', value: 'WA' },
  { name: 'West Virginia', value: 'WV' },
  { name: 'Wisconsin', value: 'WI' },
  { name: 'Wyoming', value: 'WY' },
]

// Canada Provinces
export const CANADA_PROVINCES_LIST: SelectItem[] = [
  { name: 'Alberta', value: 'AB' },
  { name: 'British Columbia', value: 'BC' },
  { name: 'Manitoba', value: 'MB' },
  { name: 'New Brunswick', value: 'NB' },
  { name: 'Newfoundland and Labrador', value: 'NL' },
  { name: 'Nova Scotia', value: 'NS' },
  { name: 'Ontario', value: 'ON' },
  { name: 'Prince Edward Island', value: 'PE' },
  { name: 'Quebec', value: 'QC' },
  { name: 'Saskatchewan', value: 'SK' },
]
